import Menu from '../../components/globalComponents/headerMenu/menu';
import TechServicesSection from '../../components/homePageComponents/techServicesSection/techServicesSection';
import ProductShowcase from '../../components/homePageComponents/productShowcase/productShowcase';
import SocialIcons from '../../components/globalComponents/socialIcons/socialIcons';
import GradientLine from '../../components/globalComponents/gradientLine/gradientLine';
import Footer from '../../components/globalComponents/footer/footer';
import './homePage.scss';
import InnovationDevelopment from '../../components/homePageComponents/innovationDevelopment/innovationDevelopment';
import WhyWonderaly from '../../components/homePageComponents/whyWonderaly/whyWonderaly';
import HeaderHome from '../../components/homePageComponents/headerHome/headerHome';

const HomePage = () => {
  return (
    <div className="homepage-wrapper">
      <div className="page-content">
        <main className="main-content">
          <Menu />
          <HeaderHome />
          <WhyWonderaly />
          <TechServicesSection />
          <hr className="divider-line" />
          <ProductShowcase />
          <InnovationDevelopment />
          <SocialIcons />
          <GradientLine />
        </main>
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
